import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Alert,
} from '@mui/material';

const EditDialog = ({open, onClose, editForm, setEditForm, onSave}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <DialogTitle>Edit API Credential</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{mt: 1}}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label='Credential Name'
              value={editForm.credential_name}
              onChange={(e) =>
                setEditForm({...editForm, credential_name: e.target.value})
              }
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label='Username'
              value={editForm.username}
              onChange={(e) =>
                setEditForm({...editForm, username: e.target.value})
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label='Password'
              type='password'
              value={editForm.password}
              onChange={(e) =>
                setEditForm({...editForm, password: e.target.value})
              }
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={editForm.is_system_file_upload || false}
                  onChange={(e) =>
                    setEditForm({
                      ...editForm,
                      is_system_file_upload: e.target.checked,
                    })
                  }
                />
              }
              label='System File Upload Credential (Only one can be active)'
            />
            {editForm.is_system_file_upload && (
              <Alert severity='info' sx={{mt: 1}}>
                Setting this as system file upload will unset the flag on other
                credentials.
              </Alert>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSave} variant='contained'>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

EditDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  editForm: PropTypes.shape({
    credential_name: PropTypes.string,
    username: PropTypes.string,
    password: PropTypes.string,
    is_system_file_upload: PropTypes.bool,
  }).isRequired,
  setEditForm: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default EditDialog;
